import React from "react";

class PDFPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {}

  render() {
    const logo = require("images/logos/dp-logo-small.png");
    return (
      <div className="pdf-810-1110">
        <div className={`pdf-page standard-color-bg ${this.props.className}`}>{this.props.children}</div>
        <div className="pdf-footer standard-color-bg align-items-center justify-content-between">
          {/* {this.props.hideLogo ? (
            <img src={`/datapulse${logo}`} className="pdf-footer-logo" style={{ opacity: "0" }} />
          ) : (
            <>
              <img src={`/datapulse${logo}`} className="pdf-footer-logo" />
            </>
          )} */}

          <p>{this.props.pageNumber}</p>
        </div>
      </div>
    );
  }
}

export default PDFPage;
